import * as React from 'react'
import I18n from '../../../../core/i18n'
import styled, { AnyStyledComponent } from 'styled-components'
import * as constants from '../../../../static/constants'
import ReactSelect from 'react-select'
import { agentService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AgentLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'

declare var window: interfaces.IWindow

const selectCustomStyles = {
  control: (provided, _) => ({
    ...provided,
    border: `1px solid ${constants.COLORS.divider}`,
    borderRadius: 4,
    '&:hover': { border: `1px solid ${constants.COLORS.primary}` },
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: constants.COLORS.primary,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
}

const FIELDS = {
  post_id: 'post_id',
  member_post_ids: 'member_post_ids',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('post_member_post', { scope: 'activerecord.models' }),
})

interface IProps {
  post: IJsonResponse
  relatable_posts: IJsonResponse
  user: IJsonResponse
}

const AgentRelatedPostEdit: React.FC<IProps> = props => {
  const post = props.post ? agentService.getDataFromJson(props.post).data : null
  const { data: user } = agentService.getDataFromJson(props.user)
  const { data: relatablePosts } = agentService.getDataFromJson(props.relatable_posts)
  const postId = post ? String(post.id) : null
  const [memberPosts, setMemberPosts] = React.useState(
    post
      ? post.member_posts.map(rp => {
          return { value: String(rp.id), label: rp.name }
        })
      : []
  )

  const handleSubmit = React.useCallback(async () => {
    const memberPostIds = memberPosts ? memberPosts.map(p => Number(p.value)) : []
    const { flush } = await agentService.updateMemberPosts(postId, memberPostIds)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/agent/member_posts'
  }, [postId, memberPosts])

  return (
    <SidebarLayout user={user} showSidebar={true}>
      <AgentLayoutEdit
        model="member_posts"
        title={title}
        fields={FIELDS}
        hideAgentNav={true}
        indexLink="/agent/member_posts"
        formItems={
          <>
            <InputText name="post_id" readonly={true} defaultValue={post.name} label="Tour" />
            <input type="hidden" name="post_id" value={post.id} />
            <S.ReactSelectWrapper>
              <p className="ReactSelect_Title">{I18n.t('generic.member_posts')}</p>
              <div className="ReactSelect_Main">
                <ReactSelect
                  name="member_post_ids"
                  placeholder={I18n.t('generic.member_posts')}
                  options={relatablePosts.map(p => ({
                    value: String(p.id),
                    label: p.name,
                  }))}
                  isMulti={true}
                  onChange={setMemberPosts}
                  styles={selectCustomStyles}
                  defaultValue={memberPosts}
                  menuPortalTarget={document.querySelector('body')}
                />
              </div>
            </S.ReactSelectWrapper>
          </>
        }
        handleSubmit={handleSubmit}
      />
    </SidebarLayout>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 240px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
  .RangeTag_Wrapper {
    width: 100%;
  }
`

export default AgentRelatedPostEdit
